import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';

const toolbarMargin = { marginBottom: '10px' };

const JobFormButtons = ({ persisted, saveJob, runJob, addTask, jobValid, destroyJob }) => (
  <div>
    <ButtonToolbar style={toolbarMargin}>
      <Button
        bsStyle='link'
        onClick={addTask}
        className='btn-link-no-sidepad'
      >
        Add another step
      </Button>
    </ButtonToolbar>

    <ButtonToolbar style={toolbarMargin}>
      { persisted &&
        <Button
          bsStyle='danger'
          onClick={destroyJob}
        >
          Delete job
        </Button>
      }

      <Button
        bsStyle='primary'
        onClick={saveJob}
        disabled={!jobValid}
      >
        Save Job
      </Button>

      { !persisted &&
        <Button
          bsStyle='success'
          onClick={runJob}
          disabled={!jobValid}
        >
          Run Job
        </Button>
      }
    </ButtonToolbar>
  </div>
);

export default JobFormButtons;

JobFormButtons.propTypes = {
  persisted: PropTypes.bool,
  saveJob: PropTypes.func,
  runJob: PropTypes.func,
  addTask: PropTypes.func,
  jobValid: PropTypes.bool,
  destroyJob: PropTypes.func,
};
